var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classes},[_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }